import { WIDGET_BUILDER_TRANSITION } from 'sierra-client/features/insights/widget-builder/data-selectors/animation-constants'
import { View } from 'sierra-ui/primitives'
import styled from 'styled-components'

export const AnimationContainer = styled(View).attrs({
  animated: true,
  layout: 'position',
  transition: WIDGET_BUILDER_TRANSITION,
})``
